export default __webpack_public_path__ + "static/ameena-balthazaurus-scroll-5b927294ac7e232d9fa79dfc79ad2b10.gif";